import colors from "./colors";

export default colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/src/category20c.js
// module id = 1649
// module chunks = 3